import React from "react";

const outcomes = [
  {
    img: "./../assets/corporateAssert/Outcome 1.png",
    title: "Peak Performance",
    subtitle: "Less Stress, More Focus",
  },
  {
    img: "./../assets/corporateAssert/Outcome 2.png",
    title: "Fewer Sick Days",
    subtitle: "Stronger Immunity, High Energy",
  },
  {
    img: "./../assets/corporateAssert/Outcome 3.png",
    title: "Higher Productivity",
    subtitle: "Better Digestion & Sleep",
  },
  {
    img: "./../assets/corporateAssert/Outcome 4.png",
    title: "Smarter Savings",
    subtitle: "Lower Healthcare Costs",
  },
  {
    img: "./../assets/corporateAssert/Outcome 5.png",
    title: "Higher Job satisfaction",
    subtitle: "Happier Workplace",
  },
];

const WellnessProgram = () => {
  return (
    <div className="Wellness-container">
    <div className="wellness-program mb-30">
      <div className="wellness-program__container mt-10">
        <div className="wellness-program-container">
          <h2 className="wellness-program__title">
          Sustained well-being that boosts ROI
          </h2>
          <p className="wellness-program__description">
          Investing in employee wellness isn’t just about health-it’s about business growth.Prioritizing well-being is a win-win, ensuring long-term success for both individuals and organizations.
          </p>
          <h2 className="wellness-program__title">Outcomes</h2>
        </div>

        <div className="marquee">
          <div className="marquee__inner">
            {[...outcomes, ...outcomes].map((item, index) => (
              <div key={index} className="marquee__item">
                <img
                  src={item.img}
                  className="outcome-item__image"
                  alt={item.title}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="percentage mt-20 mb-10">
          <img
            src="./../assets/corporateAssert/checkIcon.png"
            className="checkIcon"
            alt="check"
          />
          <p className="percentage-text">
          <b>73% </b>of users say that <b>Ayur.AI</b> has improved their overall health.
          </p>
        </div>
      </div>
    </div>
    </div>
  );
};

export default WellnessProgram;
